import { Injectable } from "@angular/core";

import { ValApiResultat, ValBaseService } from "../../../val-services-communs-lib/src/public-api";
import { ValAppSettingsService } from "../../../val-app-settings-lib/src/public-api";
import { GenererEtTransmettrePieceResultat, GenererEtTransmettrePieceRequest } from "./GenererEtTransmettrePiece";
import { RecupererEtEnregistrerPiecesResultat } from "./RecupererEtEnregistrerPieces";
import { SynchroniserStatutsPiecesResultat } from "./SynchroniserStatutsPieces";
import { MajStatutPieceRequest } from "./MajStatutPiece";
import { RecupererEtEnregistrerEncaissementsResultat } from "./RecupererEtEnregistrerEncaissements";
import { TransmettreEncaissementsRequest, TransmettreEncaissementsResultat } from "./TransmettreEncaissements";
import { SynchroniserEtatTransmissionEncaissementsResultat } from "./SynchroniserEtatTransmissionEncaissements";
import { MettreAJourActivationPiecesVenteRequest, MettreAJourActivationPiecesVenteResultat } from "./MettreAJourActivationPiecesVente";

//Services eFact vente
@Injectable(
    {
        providedIn: 'root'
    })
export class EFactVenteService extends ValBaseService {
    //Création
    //  Paramètres
    //    appSettingsService : Service d’accès à la configuration de l’application
    constructor(private appSettingsService: ValAppSettingsService) {
        super();
    }

    //Url de base
    protected override get BaseUrl(): string {
        return `${this.appSettingsService.Configuration.UrlApi.EFact}/v1.0/sales/`;
    }

    // Transmet les pièces de vente
    //  Paramètres
    //    request : Requête de génération et transmission des pièces de vente
    //  Retourne
    //    Résultat de la génération et transmission des pièces de vente
    public async TransmettrePieces(request: GenererEtTransmettrePieceRequest): Promise<ValApiResultat<GenererEtTransmettrePieceResultat>> {
        let operation: Promise<ValApiResultat<GenererEtTransmettrePieceResultat>>;

        operation = this.ExecuterRequetePost<GenererEtTransmettrePieceResultat>("send/e-invoices", request);

        return operation;

    }

    // Récupère et enregistre les pièces électroniques de vente depuis la source externe
    public async RecupererPieces(): Promise<ValApiResultat<RecupererEtEnregistrerPiecesResultat>> {
        return this.ExecuterRequeteGet<RecupererEtEnregistrerPiecesResultat>("retrieve-e-invoices");
    }

    // Récupère et enregistre les encaissements depuis la source externe
    public async ImporterEncaissements(): Promise<ValApiResultat<RecupererEtEnregistrerEncaissementsResultat>> {
        return this.ExecuterRequeteGet<RecupererEtEnregistrerEncaissementsResultat>("retrieve-payments");
    }

    // Transmet les encaissements des pièces de vente à la PA
    public async TransmettreEncaissements(request: TransmettreEncaissementsRequest): Promise<ValApiResultat<TransmettreEncaissementsResultat>> {
        return this.ExecuterRequetePost<TransmettreEncaissementsResultat>("send/payments", request);
    }

    // Accuse réception des encaissements auprès de la source externe
    public async AccuserReceptionEncaissements(): Promise<ValApiResultat<object>> {
        return this.ExecuterRequetePatch<object>("payments/last-retrieval-date/propagate", {});
    }

    // Synchronise les statuts des pièces de vente avec la source externe
    public async SynchroniserStatutsPieces(): Promise<ValApiResultat<SynchroniserStatutsPiecesResultat>> {
        return this.ExecuterRequetePatch<SynchroniserStatutsPiecesResultat>("status", {});
    }

    public async SynchroniserStatutActuelPieces(request: MajStatutPieceRequest): Promise<void> {
        await this.ExecuterRequetePatch<void>("status/propagate", request);
    }

    // Synchronise les états de transmission des encaissements avec la source externe
    public async SynchroniserEtatTransmissionEncaissements(): Promise<ValApiResultat<SynchroniserEtatTransmissionEncaissementsResultat>> {
        return this.ExecuterRequetePatch<SynchroniserEtatTransmissionEncaissementsResultat>("payments/status", {});
    }

    // Active ou désactive les pièces de vente de la sélection (SU #118690)
    //  Paramètres
    //    request : Identifiants des pièces à traiter et état cible
    //  Retourne
    //    Nombre de pièces modifiées, inchangées et non autorisées
    public async MettreAJourActivationPieces(request: MettreAJourActivationPiecesVenteRequest): Promise<ValApiResultat<MettreAJourActivationPiecesVenteResultat>> {
        return this.ExecuterRequetePatch<MettreAJourActivationPiecesVenteResultat>("activation", request);
    }
}
